import { render } from "./afterMovies.vue?vue&type=template&id=13ba4f5f"
const script = {}

import "./afterMovies.vue?vue&type=style&index=0&id=13ba4f5f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__